<template>
<div class="footer">
    <div class="container">
      <!-- Affiliations Section -->
      <div class="affiliations-section">
        <h4 class="affiliations-title">Affiliations</h4>
        <div class="affiliations-logos">
          <a 
            href="https://www.maltahealthnetwork.org/" 
            target="_blank" 
            rel="noopener noreferrer"
            class="affiliation-logo-link"
          >
            <img 
              src="https://www.maltahealthnetwork.org/wp-content/uploads/2017/03/MHN-logo.png" 
              alt="Malta Health Network" 
              class="affiliation-logo"
            />
          </a>
        </div>
      </div>

      <div class="row logos mb-3" v-if="false">
        <img src="../assets/partner_01.svg" alt="Partner 01" class="col-lg-1 col-3">
        <img src="../assets/partner_01.svg" alt="Partner 01" class="col-lg-1 col-3">
        <img src="../assets/partner_01.svg" alt="Partner 01" class="col-lg-1 col-3">
      </div>

      <div class="row pb-5 pt-5">
        <div  class="col-lg-3 col-10">
         <h4> Contact us: </h4>
         <ol>Phone: +356 7940 5440</ol>
         <ol>E-mail: revivemalta@yahoo.com</ol>
        </div>
      
        <div  class="col-lg-3 col-10">
           <h4> Donate by SMS:</h4>
           <ol>
           <p>€2.33 - 5061-7356</p>
           </ol>
           <ol>
           <p>€4.66 - 5061-8196</p>
           </ol>
           <ol>
           <p>€6.99 - 5061-8927</p>
           </ol>
       </div>
  
        <div  class="col-lg-6 col-10">
         <h4> Donate via bank transference: </h4>
         <ol> IBAN APS: MT53 APSB 7701 300 00000 460 2901 0014</ol>
         <ol> IBAN BOV: MT87 VALL 2201 3000 0000 5002 3183 433</ol>
         <ol> BOV Mobile Pay: +356 7940 5440</ol>
        </div>
    </div>
    </div>
  </div>
</template>
<script setup>
</script>
<style lang="scss">
    .footer {
        background: linear-gradient(10deg, rgba(178, 199, 91, 1) 10%, rgba(0, 83, 1, 0.7) 75%);
        color: var(--secondary-font-color);    

        .logos {
          justify-content: center;
        }

        .info {
            width: 100%;

            p {
                margin: 0
            }
        }

        // Affiliations Section
        .affiliations-section {
            padding: 2rem 0;
            text-align: center;
            border-bottom: 1px solid rgba(255, 255, 255, 0.2);
            margin-bottom: 1rem;

            .affiliations-title {
                color: var(--secondary-font-color);
                margin-bottom: 1.5rem;
                font-size: 1.25rem;
                font-weight: 600;
            }

            .affiliations-logos {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 2rem;
                flex-wrap: wrap;
                max-width: 100%;

                @media (max-width: 768px) {
                    flex-wrap: nowrap;
                    overflow-x: auto;
                    justify-content: flex-start;
                    padding: 0 1rem;
                    -webkit-overflow-scrolling: touch;
                    
                    &::-webkit-scrollbar {
                        height: 4px;
                    }
                    
                    &::-webkit-scrollbar-track {
                        background: rgba(255, 255, 255, 0.1);
                        border-radius: 2px;
                    }
                    
                    &::-webkit-scrollbar-thumb {
                        background: rgba(255, 255, 255, 0.3);
                        border-radius: 2px;
                    }
                }
            }

            .affiliation-logo-link {
                display: block;
                transition: opacity 0.3s ease, filter 0.3s ease;
                padding: 0.5rem;

                .affiliation-logo {
                    max-width: 5rem;
                    max-width: 15%;
                    cursor: pointer;
                    height: auto;
                    filter: grayscale(1);
                    transition: filter 0.3s ease, opacity 0.3s ease, transform 0.3s ease;
                    display: block;
                    
                    &:hover {
                        opacity: 0.8;
                        filter: grayscale(0%);
                        transform: scale(1.1);
                    }

                    @media (max-width: 768px) {
                        min-width: max(4rem, 30%);
                        max-width: max(4rem, 30%);
                    }
                }
            }
        }
    }
</style>